import classNames from 'classnames';
import { useMemo } from 'react';
import { LabelBodyHeadline, Spacer } from '../components';
import { ChevronRightIcon } from '../icons';
import { ExerciseDto, ExerciseStatus } from '../interfaces';
import { ExerciseStatusView } from './ExerciseStatusView';

type Props = {
    exercise: ExerciseDto;
    onOpenExercise: () => void;
    className?: string;
};

export function NestedExerciseView({
    exercise,
    onOpenExercise,
    className,
}: Props) {
    const hasLoggedData = useMemo(
        () => Object.keys(exercise.Data).length > 0,
        [exercise],
    );
    const isDisabled = exercise.Status === ExerciseStatus.Blocked;

    return (
        <div
            onClick={isDisabled ? undefined : onOpenExercise}
            className={classNames(
                className,
                'flex flex-row items-center py-20',
                { 'cursor-pointer': !isDisabled },
            )}
        >
            <ExerciseStatusView
                hasLoggedData={hasLoggedData}
                status={exercise.Status}
                isVideo={exercise.VideoMetadata != null}
                useCheckmark
            />
            <LabelBodyHeadline
                className={classNames('text-dark-red', {
                    'ml-10': exercise.Status == ExerciseStatus.Completed,
                    'opacity-60': isDisabled,
                })}
            >
                {exercise.Name}
            </LabelBodyHeadline>
            <Spacer />
            <ChevronRightIcon />
        </div>
    );
}
